'use strict';

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.set");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.string.ends-with");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _dec, _class, _dec2, _class2, _dec3, _class3, _class4, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Choice = require('./Choice');

var _Icon = require('../components/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _util = require('../util');

var _cards = require('../cards');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {
    container: {
      width: '100%',
      background: theme.bgMeta,
      borderTop: theme.cardBorder
    },
    toolbar: {
      padding: [[10, 10, 5]]
    },
    version: {
      width: '100%',
      padding: 10,
      opacity: 0.8,
      '&:not(:last-child)': {
        borderBottom: theme.cardBorder
      },
      '& > *:first-child': {
        fontSize: '1.4em',
        marginBottom: 10,
        '& mark': {
          background: theme.bgLowlight
        }
      }
    },
    tag: {
      lineHeight: 1.5,
      fontSize: '1.2rem',
      background: theme.bgCard,
      borderColor: theme.colorMeta,
      fontWeight: 'bold',
      borderRadius: '2em',
      marginBottom: 5,
      display: 'inline-block',
      border: [[1, 'solid']],
      '&:not(:last-child)': {
        marginRight: 10
      }
    },
    tagAccept: {
      borderColor: theme.accept,
      background: theme.accept
    },
    tagReject: {
      borderColor: theme.reject,
      background: theme.reject
    },
    tagText: {
      background: theme.bgCard,
      lineHeight: 1,
      padding: [[2, 7, 4]],
      margin: [[2, 0, 2, 2]],
      borderRadius: 'inherit',
      display: 'inline-block'
    },
    tagTextSimple: {
      verticalAlign: 'text-top',
      padding: [[1, 7, 0]],
      color: theme.colorMeta,
      background: 'transparent',
      margin: 0
    },
    tagIcon: {
      margin: [[0, 5, 0, 2]],
      verticalAlign: 'middle',
      position: 'relative',
      top: -1,
      color: theme.colorButton
    },
    choiceOption: {
      alignItems: 'flex-start',
      '& input': {
        marginTop: 6
      }
    },
    choiceOptionTags: {
      lineHeight: 1,
      padding: [[1, 15, 0, 0]]
    }
  };
};

var SessionTag = (_dec = (0, _util.withStyles)(styles), _dec(_class = function (_React$Component) {
  _inherits(SessionTag, _React$Component);

  function SessionTag() {
    _classCallCheck(this, SessionTag);

    return _possibleConstructorReturn(this, (SessionTag.__proto__ || Object.getPrototypeOf(SessionTag)).apply(this, arguments));
  }

  _createClass(SessionTag, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          id = _props.id,
          _props$content = _props.content,
          content = _props$content === undefined ? {} : _props$content,
          _props$styled = _props.styled,
          styled = _props$styled === undefined ? true : _props$styled,
          classes = _props.classes;
      var answer = content.answer;
      var tagClassNames = (0, _classnames2["default"])(classes.tag, (_classNames = {}, _defineProperty(_classNames, classes.tagAccept, styled && answer === 'accept'), _defineProperty(_classNames, classes.tagReject, styled && answer === 'reject'), _classNames));
      var tagTextClassNames = (0, _classnames2["default"])(classes.tagText, _defineProperty({}, classes.tagTextSimple, !styled));
      return _react2["default"].createElement('span', {
        className: tagClassNames
      }, _react2["default"].createElement('span', {
        className: tagTextClassNames
      }, id), answer && styled && _react2["default"].createElement(_Icon2["default"], {
        size: 16,
        name: answer,
        className: classes.tagIcon
      }));
    }
  }]);

  return SessionTag;
}(_react2["default"].Component)) || _class);
var ChoiceOption = (_dec2 = (0, _util.withStyles)(styles), _dec2(_class2 = function (_React$Component2) {
  _inherits(ChoiceOption, _React$Component2);

  function ChoiceOption() {
    _classCallCheck(this, ChoiceOption);

    return _possibleConstructorReturn(this, (ChoiceOption.__proto__ || Object.getPrototypeOf(ChoiceOption)).apply(this, arguments));
  }

  _createClass(ChoiceOption, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          _props2$meta = _props2.meta,
          meta = _props2$meta === undefined ? {} : _props2$meta,
          children = _props2.children,
          classes = _props2.classes,
          props = _objectWithoutProperties(_props2, ['meta', 'children', 'classes']);

      var _meta$sessions = meta.sessions,
          sessions = _meta$sessions === undefined ? [] : _meta$sessions;
      return _react2["default"].createElement(_Choice.Option, _extends({}, props, {
        className: classes.choiceOption
      }), children, !!sessions.length && _react2["default"].createElement('div', {
        className: classes.choiceOptionTags
      }, sessions.map(function (id) {
        return _react2["default"].createElement(SessionTag, {
          key: id,
          id: id,
          styled: false
        });
      })));
    }
  }]);

  return ChoiceOption;
}(_react2["default"].Component)) || _class2);
var Review = (_dec3 = (0, _util.withStyles)(styles), _dec3(_class3 = (_temp = _class4 = function (_React$Component3) {
  _inherits(Review, _React$Component3);

  function Review() {
    _classCallCheck(this, Review);

    return _possibleConstructorReturn(this, (Review.__proto__ || Object.getPrototypeOf(Review)).apply(this, arguments));
  }

  _createClass(Review, [{
    key: 'getVersionInterface',
    value: function getVersionInterface(viewId) {
      if (viewId === 'classification') return 'text';
      if (viewId.endsWith('_manual')) return viewId.split('_manual')[0];
      return viewId;
    }
  }, {
    key: 'getMainContent',
    value: function getMainContent(viewId) {
      var content = this.props.content;
      var _content$versions = content.versions,
          versions = _content$versions === undefined ? [] : _content$versions;

      if (viewId == 'choice') {
        var byId = Object.assign.apply(Object, [{}].concat(_toConsumableArray(content.options.map(function (_ref) {
          var id = _ref.id;
          return _defineProperty({}, id, []);
        }))));
        versions.forEach(function (_ref3) {
          var accept = _ref3.accept,
              sessions = _ref3.sessions;
          return accept.forEach(function (id) {
            byId[id] = [].concat(_toConsumableArray(byId[id]), _toConsumableArray(sessions));
          });
        });
        var newOptions = content.options.map(function (opt) {
          return _extends({}, opt, {
            meta: {
              sessions: [].concat(_toConsumableArray(new Set(byId[opt.id]))).sort()
            }
          });
        });
        return _extends({}, content, {
          options: newOptions
        });
      } // We're returning the main content instead of the default version here,
      // otherwise changes to it won't be reflected in the UI, since it's not updated


      return content;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames3,
          _this4 = this;

      var _props3 = this.props,
          content = _props3.content,
          SessionTag = _props3.SessionTag,
          ChoiceOption = _props3.ChoiceOption,
          classes = _props3.classes;
      var view_id = content.view_id,
          _content$versions2 = content.versions,
          versions = _content$versions2 === undefined ? [] : _content$versions2;
      var viewId = view_id || (0, _util.findInterface)(content);
      var versionViewId = this.getVersionInterface(viewId);
      var isManual = viewId.endsWith('_manual');
      var MainCard = _cards.INTERFACES[viewId];
      var VersionCard = _cards.INTERFACES[versionViewId];
      var containerClassNames = (0, _classnames2["default"])(classes.container, (_classNames3 = {}, _defineProperty(_classNames3, classes.toolbar, !isManual), _defineProperty(_classNames3, classes.versions, isManual), _classNames3));
      var mainContent = this.getMainContent(viewId);
      return _react2["default"].createElement(_react.Fragment, null, _react2["default"].createElement(MainCard, _extends({}, this.props, {
        content: mainContent,
        ChoiceOption: ChoiceOption
      }), _react2["default"].createElement('div', {
        className: containerClassNames
      }, versions.map(function (version, i) {
        return isManual ? _react2["default"].createElement('div', {
          key: i,
          className: classes.version
        }, _react2["default"].createElement(VersionCard, _extends({}, _this4.props, {
          content: version,
          config: _this4.props.config,
          nowrap: true
        })), (version.sessions || []).map(function (sessionId) {
          return _react2["default"].createElement(SessionTag, {
            key: sessionId,
            id: sessionId,
            content: version,
            styled: false
          });
        })) : _react2["default"].createElement(_react.Fragment, {
          key: i
        }, (version.sessions || []).map(function (sessionId) {
          return _react2["default"].createElement(SessionTag, {
            key: sessionId,
            id: sessionId,
            content: version
          });
        }));
      }))));
    }
  }]);

  return Review;
}(_react2["default"].Component), _class4.id = 'review', _class4.defaultProps = {
  content: {},
  config: {},
  SessionTag: SessionTag,
  ChoiceOption: ChoiceOption
}, _temp)) || _class3);
exports["default"] = Review;